module.exports = __webpack_public_path__ + "static/media/14UNEP1.8c0a0d98.jpg";